import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {Configuration} from '../Shared/Constants/app.constants';
import { Observable }     from 'rxjs/Observable';
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {TreeModule, TreeNode} from 'primeng/primeng';
import { contentHeaders } from '../Core/Headers';
import { AuthHttp } from 'angular2-jwt';
import { ResponseContentType } from '@angular/http';
import { environment } from '../../environments/environment';


@Injectable()
export class ProfileDataService {
    private headers: Headers;
    private apiUrl: string;
    private actionUrl: string;
    private token: any;
    private readonly APIEndPoint: any = environment.apiEndPoint;

    constructor(private http: Http, private authHttp: AuthHttp) {
        this.headers = new Headers();
        this.token = window.localStorage.getItem('id_token');
    }

	GetTeamMemberProfile(Id: any) {
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetTeamMemberProfile?ID=' + Id + '';
        return this.authHttp.get(this.apiUrl, { headers: this.headers }).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

	GetTeamMembers(Id: any) {
        // alert(Id)
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetTeamMembers?ID=' + Id + '';
        return this.authHttp.get(this.apiUrl, { headers: this.headers }).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

    GetTodayBirthdays() {
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetTeamMemberBirthday';
        return this.authHttp.get(this.apiUrl, { headers: this.headers }).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

    getImagePath() {
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/TeamMember/getImagePath';
        return this.authHttp.get(this.apiUrl, { headers: this.headers }).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

     GetHRTeamMembers() {
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetHRTeamMembers';
        return this.authHttp.get(this.apiUrl, { headers: this.headers }).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }
    GetHRBPTeamMembers() {
       this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetHRBPTeamMembers';
       return this.authHttp.get(this.apiUrl).map((res: Response) => {

        let data = res.json();
        return data;
    });
   }

     GetUnitManagerTeamMembers() {
         // alert(Id)
         this.headers.append('Accept', 'application/json');
         this.headers.append('Content-Type', 'application/json');

         this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetUnitManagerTeamMembers';
         return this.authHttp.get(this.apiUrl, { headers: this.headers }).map((res: Response) => {
             let data = res.json();
             return data;
         });
     }

	 GetDropdowns(_dropdownfor: any) {
        this.apiUrl = this.actionUrl + 'LOV';
        this.apiUrl = this.apiUrl + "/GetLOVDataForDropdown?Type=" + _dropdownfor;

        return this.http.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

	 GetDeliveryUnit(ID: any) {
        //alert();
        this.apiUrl = this.APIEndPoint + '/api/DeliveryUnit/GetDeliveryUnit?id=' + 0 + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

    GetManagers() {
        //alert();
        this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetManagers';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {

            let data = res.json();
            return data;
        });
    }
    GetTeamLeads() {
        //alert();
        this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetTeamLeads';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {

            let data = res.json();
            return data;
        });
    }

    GetTeamMembersName() {
        this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetTeamMemberList';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {

            let data = res.json();
            return data;
        });
    }

    GetTeamFunctionalLeads() {
        //alert();
        this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetTeamFunctionalLeads';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {

            let data = res.json();
            return data;
        });
    }

	TeamMemberProfileSave(teamMemberProfile: any) {
        this.apiUrl = this.APIEndPoint + '/api/TeamMember/TeamMemberProfileSave?ID=0'
        let requestOption = new RequestOptions({ headers: this.headers });
        let data = JSON.stringify(teamMemberProfile);
        return this.authHttp.post(this.apiUrl, teamMemberProfile, requestOption).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

	UserSave(teamMember: any) {
    debugger;
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(teamMember);
        return this.authHttp.post(this.APIEndPoint + '/api/TeamMember/UserSave', body, options).map(res => {
            return res.json();
        });
    }

	SaveProfile(teamMemberProfile: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(teamMemberProfile);
        return this.authHttp.post(this.APIEndPoint + '/api/TeamMember/SaveProfile', body, options).map(res => {
            return res.json();
        });
    }

    SaveWorkPlan(teamMemberProfile: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(teamMemberProfile);
        return this.authHttp.post(this.APIEndPoint + '/api/TeamMember/SaveWorkPlan', body, options).map(res => {
            return res.json();
        });
    }

    // GetWorkPlanByUserID(teamMemberProfile: any) {
    //     let headers = new Headers({ 'Content-Type': 'application/json' });
    //     let options = new RequestOptions({ headers: headers });
    //     let body = JSON.stringify(teamMemberProfile);
    //     return this.authHttp.post(this.APIEndPoint + '/api/TeamMember/GetWorkPlanByUserID', body, options).map(res => {
    //         return res.json();
    //     });
    // }

    GetWorkPlanByUserID(Id: any) {
        // alert(Id)
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetWorkPlanByUserID?TeamMemberCode=' + Id + '';
        return this.authHttp.get(this.apiUrl, { headers: this.headers }).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

	DeleteProfile(teamMemberProfile: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(teamMemberProfile);

        return this.authHttp.post(this.APIEndPoint + '/api/TeamMember/DeleteProfile', body, options).map(res => {
            console.log('response=' + res.json());
        }).subscribe(
            data => console.log("data=" + data),
            err => console.log("error=" + err),
            () => console.log('yay')
            );
    }

    GetRoles() {
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/Roles/GetRoles';
        return this.authHttp.get(this.apiUrl, { headers: this.headers }).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

	AddRole(role: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(role);

        return this.authHttp.post(this.APIEndPoint + '/api/Roles/AddRole', body, options).map(res => {
            console.log('response=' + res.json());
        }).subscribe(
            data => console.log("data=" + data),
            err => console.log("error=" + err),
            () => console.log('yay')
            );
    }

    GetUsers() {
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/Roles/GetUsers';
        return this.authHttp.get(this.apiUrl, { headers: this.headers }).map((res: Response) => {
            let data = res.json();
            console.log(JSON.stringify(data));
            return data;
        });
    }

	AddUser(user: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(user);

        return this.authHttp.post(this.APIEndPoint + '/api/Roles/AddUser', body, options).map(res => {
            return res.json();
        });
    }

    GetRoleNameList() {

        this.apiUrl = this.APIEndPoint + "/api/Roles/GetRoleList";
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //return this.renamePropertyNames(JSON.stringify(data));
            return data;
        });

    }

    GetPages() {
        this.apiUrl = this.APIEndPoint + "/api/Pages/GetPages";
        return this.http.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //return this.renamePropertyNames(JSON.stringify(data));
            return data;
        });
    }

	GetPagesByUserID(userId: any) {
        this.apiUrl = this.APIEndPoint + "/api/Pages/GetPagesByUserID?UserID=" + userId;
        return this.http.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //return this.renamePropertyNames(JSON.stringify(data));
            return data;
        });
    }

	GetPagesByRoleID(RoleID: any) {
        this.apiUrl = this.APIEndPoint + "/api/Pages/GetPagesByRoleID?RoleID=" + RoleID;
        return this.http.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //return this.renamePropertyNames(JSON.stringify(data));
            return data;
        });
    }

	AddPages(page: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(page);
        // console.log(JSON.stringify(body));

        return this.authHttp.post(this.APIEndPoint + '/api/Pages/SavePages', body, options).map(res => {
            console.log('response=' + res.json());
        }).subscribe(
            data => console.log("data=" + data),
            err => console.log("error=" + err),
            () => console.log('yay')
            );
    }

	renamePropertyNames(json: any) {

        var obj = JSON.parse(json);
        for (var i = 0; i < obj.length; i++) {
            if (obj[i].hasOwnProperty("name")) {
                obj[i]["label"] = obj[i]["name"];
                delete obj[i]["name"];
            }
            if (obj[i].hasOwnProperty("id")) {
                obj[i]["value"] = obj[i]["id"];
                delete obj[i]["id"];
            }
        }
        return obj;
    }

	GetUserExperience(Id: any) {
        // alert(Id)
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/UserExperience/Get?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //alert(1)
            //console.log(JSON.stringify(data));
            return data;
        });
    }

	GetNewUserExperience(Id: any)
    {
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');
        this.apiUrl = this.APIEndPoint + '/api/UserExperience/GetNewUserExperience?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

	SaveUserExperience(userExperience: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(userExperience);
        //console.log(JSON.stringify(body));
        return this.authHttp.post(this.APIEndPoint + '/api/UserExperience/SaveUserExperience', body, options).map(res => {
            return res.json();
        });
    }

	Getdependent(Id: any) {
        // alert(Id)
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/Dependent/Get?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //alert(1)
            //console.log(JSON.stringify(data));
            return data;
        });
    }

	GetNewDependent(Id: any) {

        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/Dependent/GetNewDependent?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
           // alert(1)
            //console.log(JSON.stringify(data));
            return data;
        });
    }

	Savedependent(dependent: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(dependent);
        //console.log(JSON.stringify(body));
        return this.authHttp.post(this.APIEndPoint + '/api/Dependent/SaveDependent', body, options).map(res => {
            return res.json();
        });
    }
  //------------- Added  By Shweta--------------------

GetPassportVisa(Id: any) {
        // alert(Id)
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/PassportVisaInfo/Get?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //console.log(JSON.stringify(data));
            return data;
        });
    }
GetNewPassportVisa(Id: any) {

        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/PassportVisaInfo/GetNewPassportVisaInfo?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //console.log(JSON.stringify(data));
            return data;
        });
    }
    SavePassportVisa(passportvisa: any) {

        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(passportvisa);
        //console.log(JSON.stringify(body));
        return this.authHttp.post(this.APIEndPoint + '/api/PassportVisaInfo/SavePassportVisaInfo', body, options).map(res => {
            return res.json();
        });
    }

    SaveProfileImageConsent(event:any, userId:any){
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.APIEndPoint + '/api/TeamMember/SaveProfileImageConsent?profileconsent=' + event + '&UserID=' + userId, options).map(res => {
        return res.json();
        });

    }

GetTaravelInfo(Id: any) {
     
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/TravelInfo/Get?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }


    GetNewTravelInfo(Id: any) {
         if(Id == "")
        {
            Id=0;
        }
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/TravelInfo/GetNewTravelInfo?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();

            //console.log(JSON.stringify(data));
            return data;
        });
    }

    SaveTravelInfo(dependent: any) {
        //alert(1)
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(dependent);
        //console.log(JSON.stringify(body));
        return this.authHttp.post(this.APIEndPoint + '/api/TravelInfo/SaveTravelInfo', body, options).map(res => {
            return res.json();
        });
    }

    GetNewBGDetail(Id: any ) {
        if(Id == "")
        {
            Id=0;
        }
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/BackgroundVerification/GetNewBackgroundVerification?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();

            //console.log(JSON.stringify(data));
            return data;
        });
    }
    GetBGDetail(Id: any) {
        // alert(Id)
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/BackgroundVerification/Get?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //alert(1)
            //console.log(JSON.stringify(data));
            return data;
        });
    }
    SaveBGDetail(dependent: any) {
        //alert(1)
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(dependent);
        //console.log(JSON.stringify(body));
        return this.authHttp.post(this.APIEndPoint + '/api/BackgroundVerification/SaveBackgroundVerification', body, options).map(res => {
            return res.json();
        });
    }

    GetNewContract(Id: any) {
         if(Id == "")
        {
            Id=0;
        }
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/ContractDetail/GetNewContractDetail?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();

            //console.log(JSON.stringify(data));
            return data;
        });
    }

    GetContract(Id: any) {
        // alert(Id)
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/ContractDetail/Get?UserID=' + Id + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            //alert(1)
            //console.log(JSON.stringify(data));
            return data;
        });
    }
      SaveContract(dependent: any) {
        //alert(1)
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let body = JSON.stringify(dependent);
        //console.log(JSON.stringify(body));
        return this.authHttp.post(this.APIEndPoint + '/api/ContractDetail/SaveContractDetail', body, options).map(res => {
            return res.json();
        });
    }
//------------------ End ----------------------------
	SaveUserPhoto(UserId: any, FileName: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        // let body = JSON.stringify(userExperience);
        //console.log(JSON.stringify(body));
        return this.authHttp.get(this.APIEndPoint + '/api/TeamMember/SaveUserPhoto?fileName=' + FileName + '&UserID=' + UserId, options).map(res => {
            return res.json();
        });
    }

	GetUserPhoto(UserId: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        // let body = JSON.stringify(userExperience);
        //console.log(JSON.stringify(body));
        return this.authHttp.get(this.APIEndPoint + '/api/TeamMember/GetUserPhotoUrl?UserID=' + UserId, options).map(res => {
            return res.json();
        });
    }

	SaveDependentPhoto(UserId: any, FileName: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        // let body = JSON.stringify(userExperience);
        //console.log(JSON.stringify(body));
        return this.authHttp.get(this.APIEndPoint + '/api/TeamMember/SaveDependentPhoto?fileName=' + FileName + '&UserID=' + UserId, options).map(res => {
            return res.json();
        });
    }

	GetDependentPhoto(UserId: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        // let body = JSON.stringify(userExperience);
        //console.log(JSON.stringify(body));
        return this.authHttp.get(this.APIEndPoint + '/api/TeamMember/GetDependentPhotoUrl?UserID=' + UserId, options).map(res => {
            return res.json();
        });
    }

	GetSpecialization(UserId: any, EducationType: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        // let body = JSON.stringify(userExperience);
        //console.log(JSON.stringify(body));
        return this.authHttp.get(this.APIEndPoint + '/api/Sepcialization/Get?UserID=' + UserId + '&EducationType=' + EducationType, options).map(res => {
            return res.json();
        });
    }

	SaveSpecialization(specialization: any) {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        // let body = JSON.stringify(userExperience);
        //console.log(JSON.stringify(body));
        let body = JSON.stringify(specialization);
        //console.log(JSON.stringify(body));
        return this.authHttp.post(this.APIEndPoint + '/api/Sepcialization/Save', body, options).map(res => {
            return res.json();
        });
    }

	GetKeyValue(lovTypeName: any) {
        this.apiUrl = this.APIEndPoint + '/api/LOV/GetKeyValue?lovTypeName=' + lovTypeName + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            return data
        });
    }

	DeleteImage(UserId: any) {
        //alert();
        this.apiUrl = this.APIEndPoint + '/api/TeamMember/DeleteImage?UserId=' + UserId + '';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            return data
        });
    }

	getTeamMemberReport() {
        this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetTeamMemberReport';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
        return  res.json();
        });
    }


    GetTeamMemberDirectory() {
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/TeamMemberDirectory/Get';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            return data;
        });  }

        
        GetVaccinationDetail(UserId: any) {
            this.headers.append('Accept', 'application/json');
            this.headers.append('Content-Type', 'application/json');
    
            this.apiUrl = this.APIEndPoint + '/api/Vaccination/Get?UserID=' + UserId;
            return this.authHttp.get(this.apiUrl).map((res: Response) => {
                let data = res.json();
                return data;
            });      
        }
    
        SaveVaccinationDetail(vaccinationDetail: any) {
            let headers = new Headers({ 'Content-Type': 'application/json' });
            let options = new RequestOptions({ headers: headers });
            let body = JSON.stringify(vaccinationDetail);
            return this.authHttp.post(this.APIEndPoint + '/api/Vaccination/Save', body, options).map(res => {
                return res.json();
            });
        }
        GetTeamMembersByID(userId: any) {
       
            this.headers.append('Accept', 'application/json');
            this.headers.append('Content-Type', 'application/json');
            this.apiUrl = this.APIEndPoint + '/api/TeamHierarchy/GetTeamMember?UserId=' + userId;
            return this.authHttp.get(this.apiUrl).map((res: Response) => {
                let data = res.json();
                return data;
            });      
        }
        GetAllTeamMembersByName() {
            
            this.headers.append('Accept', 'application/json');
            this.headers.append('Content-Type', 'application/json');
            this.apiUrl = this.APIEndPoint + '/api/TeamHierarchy/GetAllTeamMemberByName?SearchText';
            return this.authHttp.get(this.apiUrl).map((res: Response) => {
                let data = res.json();
                return data;
            });      
        }

        GetTeamManagements(Id: any) {
        // alert(Id)
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.APIEndPoint + '/api/TeamMember/GetTeamManagements?TeamMemberID=' + Id + '';
        return this.authHttp.get(this.apiUrl, { headers: this.headers }).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/Services/ProfileData.ts